var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 7.76024C5.93019 8.11522 6.2666 8.40895 6.65292 8.6215C7.03925 8.83404 7.46645 8.96043 7.90554 8.9921C8.34464 9.02377 8.78537 8.95997 9.19782 8.80503C9.61028 8.6501 9.98483 8.40764 10.2961 8.09412L12.1381 6.23922C12.6973 5.65615 13.0067 4.87523 12.9997 4.06465C12.9927 3.25406 12.6699 2.47867 12.1007 1.90548C11.5315 1.33229 10.7615 1.00716 9.95652 1.00012C9.15158 0.993073 8.37609 1.30468 7.79708 1.86782L6.741 2.92512",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 6.23976C8.06965 5.88478 7.73324 5.59105 7.34691 5.3785C6.96059 5.16596 6.53339 5.03957 6.09429 5.0079C5.6552 4.97623 5.21447 5.04003 4.80201 5.19497C4.38955 5.3499 4.01501 5.59236 3.70378 5.90588L1.86178 7.76078C1.30256 8.34385 0.993121 9.12477 1.00012 9.93536C1.00711 10.7459 1.32998 11.5213 1.89918 12.0945C2.46838 12.6677 3.23838 12.9928 4.04332 12.9999C4.84826 13.0069 5.62375 12.6953 6.20276 12.1322L7.25269 11.0749",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.463d49e5b66cccca1b03fb4933163396.svg";
export { ForwardRef as ReactComponent };